export const getAccountCollection = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const pathname = window.location.pathname;

  if (pathname.startsWith("/myaclymate")) {
    return "individuals";
  }

  return "v3-companies";
};

export const getAccountId = () => {
  if (typeof window === "undefined") {
    return "";
  }
  return window.sessionStorage.getItem("accountId") || "";
};

export const setAccountId = (id) => {
  if (typeof window === "undefined") {
    return;
  }
  window.sessionStorage.setItem("accountId", id);
};
